import * as React from "react";
import type { SVGProps } from "react";
const SvgIconDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.67.54c-1.12.13-2.06.79-2.56 1.78-.18.36-.3.81-.32 1.15l-.02.2v.04H3.13l-1.63.01-.1.05c-.24.1-.37.36-.33.61.02.13.06.2.16.3q.14.14.33.17l.6.01h.5v9.26l.04.11c.05.16.07.23.13.35.2.4.59.71 1.05.84l.16.04h7.92l.16-.04c.46-.13.85-.44 1.05-.84.06-.12.08-.19.13-.35l.03-.11V9.49l.01-4.63h.5l.6-.01q.19-.03.33-.17c.1-.1.13-.16.16-.3.04-.25-.09-.5-.34-.62l-.09-.04h-1.64l-1.64-.02v-.19c-.04-.47-.21-1.02-.46-1.43-.2-.32-.52-.67-.78-.87Q9.32.7 8.54.58C8.32.54 7.87.52 7.67.54m.06 1.15c-.28.05-.48.12-.7.22-.51.27-.9.77-1.05 1.34-.03.14-.06.32-.06.4v.06h4.16v-.05q0-.07-.02-.18c-.13-.88-.73-1.53-1.6-1.75-.1-.03-.2-.04-.41-.04zM3.79 9.36c0 3.27 0 4.52.02 4.58q.06.26.3.36c.06.02.47.02 3.88.02 3.18 0 3.84 0 3.89-.02.15-.06.28-.2.3-.36.02-.06.03-1.3.03-4.58v-4.5H3.8zm2.5-2.45c-.16.04-.33.17-.4.32l-.04.09v4.54l.04.1c.05.11.17.22.28.28.08.03.11.04.24.04.12 0 .15 0 .23-.04q.2-.1.28-.28l.05-.1V7.32l-.04-.09q-.13-.25-.42-.32c-.1-.02-.12-.02-.22 0m3.18 0c-.16.04-.32.17-.4.32l-.04.09v4.54l.04.1q.1.18.29.28c.07.03.1.04.23.04.12 0 .16 0 .24-.04q.18-.1.28-.28l.04-.1V7.32l-.04-.09q-.14-.25-.41-.32c-.1-.02-.13-.02-.23 0"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconDelete;
